module.exports = __webpack_public_path__ + "img/005.2a640ca0.png";